export const CALL_SERVICE_TO_GET_LIST = 'CALL_SERVICE_TO_GET_LIST';
export const SET_CATEGORIES = 'SET_CATEGORIES';




// WEBPACK FOOTER //
// ./src/store/actions/category.js